/**数据更新 */
export const UPDATE_STORE = "update_store";
/**获取数据 */
export const GET_DATA = "get_data";
/**响应获取数据 */
export const GET_DATA_RESPONSE = "get_data_response";
/**窗口关闭，关闭端口 */
export const CLOSE_PORT = "close_port";
/**同步状态 */
export const SYNC_STORE = "sync_store";

export const READY_STATE = "ready";
